import { apiClient } from './apiClient';

export type TemplateClassification = {
  id: number;
  name: string;
};

export const getTemplateClassifications = (): Promise<
  TemplateClassification[]
> => apiClient.get('/template-classifications', {});
